var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxWithPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.3334H16.3333M13.8333 9.83335V14.8334M15.5 7.33335V5.66669C15.4997 5.37442 15.4225 5.08736 15.2763 4.83432C15.13 4.58128 14.9198 4.37116 14.6667 4.22502L8.83333 0.891687C8.57997 0.745406 8.29256 0.668396 8 0.668396C7.70744 0.668396 7.42003 0.745406 7.16667 0.891687L1.33333 4.22502C1.08022 4.37116 0.869983 4.58128 0.723718 4.83432C0.577452 5.08736 0.5003 5.37442 0.5 5.66669V12.3334C0.5003 12.6256 0.577452 12.9127 0.723718 13.1657C0.869983 13.4188 1.08022 13.6289 1.33333 13.775L7.16667 17.1084C7.42003 17.2546 7.70744 17.3316 8 17.3316C8.29256 17.3316 8.57997 17.2546 8.83333 17.1084L10.5 16.1584M11.75 6.83335L4.29167 2.53335",
    stroke: "#322C36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.742188 4.83344L8.00052 9.0001M8.00052 9.0001L15.2589 4.83344M8.00052 9.0001V17.3334",
    stroke: "#322C36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxWithPlus);
export default __webpack_public_path__ + "static/media/box-with-plus.4f774aa70e7ce687a5c915bc99e5a555.svg";
export { ForwardRef as ReactComponent };